import { render, staticRenderFns } from "./NoContentSection.vue?vue&type=template&id=659bbde2&scoped=true&"
import script from "./NoContentSection.vue?vue&type=script&lang=js&"
export * from "./NoContentSection.vue?vue&type=script&lang=js&"
import style0 from "./NoContentSection.vue?vue&type=style&index=0&id=659bbde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659bbde2",
  null
  
)

export default component.exports